import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { PACKAGE_NAME } from '@atlassian/jira-servicedesk-getting-started-panel-common/src/constants.tsx';
import { TaskVisibility } from '@atlassian/jsm-getting-started-panel';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { ActionProps, AdminTaskVisibilityResponse, State } from '../../types.tsx';

export type SetOpsAdminTaskVisibility = () => Promise<void>;

export const setOpsAdminTaskVisibility =
	({ teamId, cloudId }: ActionProps) =>
	({ getState, setState }: StoreActionApi<State>): SetOpsAdminTaskVisibility =>
	async () => {
		const { data } = getState();
		if (!data) {
			throw new Error('Trying to set ops admin task visibility without current GSP state.');
		}

		try {
			const adminTaskVisibilityResponse: AdminTaskVisibilityResponse = await fetchJson(
				`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/full-panel-access?platformTeamId=${teamId}
            `,
				{
					method: 'GET',
				},
			);
			const visibility = adminTaskVisibilityResponse.embeddedValue
				? TaskVisibility.Visible
				: TaskVisibility.Hidden;

			setState({
				data: {
					...data,
					properties: {
						...data.properties,
						user: {
							...data.properties.user,
							'ops-admin-tasks-visibility': visibility,
						},
					},
				},
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				data: {
					...data,
					properties: {
						...data.properties,
						user: {
							...data.properties.user,
							'ops-admin-tasks-visibility': TaskVisibility.Hidden,
						},
					},
				},
			});

			fireErrorAnalytics({
				error,
				meta: {
					id: 'setOpsAdminTaskVisibility',
					packageName: PACKAGE_NAME,

					teamName: 'Alexstrasza',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
	};
